import { useFlag } from '@calendly/feature-check-react'
import { useQueryParams } from '@calendly/hooks'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useGetUserQuery } from 'common'
import { useFetchEmptyStatesActivationDataQuery, useActivationQ3Flag } from 'features/empty_state'
import {
  fetchStatistics,
  teamWorkflowsCountSelector,
  personalWorkflowsCountSelector
} from 'features/workflows'

const useIsMeetingsEmpty = () => {
  const {
    data: { meetings: { count } = {} } = {}
  } = useFetchEmptyStatesActivationDataQuery({ fields: ['meetings'] })

  return count === 0
}

const useIsWorkflowsEmpty = () => {
  const dispatch = useDispatch()
  const personalWorkflowsCount = useSelector(personalWorkflowsCountSelector)
  const teamWorkflowsCount = useSelector(teamWorkflowsCountSelector)
  const workflowsExtractionEnabled = useFlag('raven_workflows_extraction')
  const { admin_managed: adminManaged } = useQueryParams()
  const { data: { id: userId } = {} } = useGetUserQuery()

  useEffect(() => {
    dispatch(fetchStatistics({ userId, workflowsExtractionEnabled }))
  }, [userId, workflowsExtractionEnabled, dispatch])

  return personalWorkflowsCount === 0 && teamWorkflowsCount === 0 && !adminManaged
}

const ANALYTICS_MY_CALENDLY_DROPDOWN_CONTEXT = [
  {
    subject: 'meetings',
    isEmptyState: useIsMeetingsEmpty
  },
  {
    subject: 'workflows',
    isEmptyState: useIsWorkflowsEmpty
  }
]

export const useMyCalendlyDropdownEventProps = (pathname) => {
  const isActivationQ3FlagEnabled = useActivationQ3Flag()
  if (!isActivationQ3FlagEnabled) return null

  const context = ANALYTICS_MY_CALENDLY_DROPDOWN_CONTEXT.find(({ subject }) => pathname.includes(subject))
  if (!context) return null

  const locationValue = context.isEmptyState()
    ? `empty_state_${context.subject}`
    : context.subject

  return ({
    name: 'my_calendly_admin_select',
    location: locationValue,
  })
}
